import { constants } from '../config';

const initialState = {
  done: false,
  loading: false,
  errorRequest: false,
  error: null,
};

export default function setRgpdReducer(state = initialState, action) {
  switch (action.type) {
    case constants.SET_RGPD:
      return { ...state, loading: true, errorRequest: false, error: null };
    case constants.SET_RGPD_SUCCESS: {
      return { ...state, loading: false, done: true };
    }
    case constants.SET_RGPD_FAIL:
      return { ...state, loading: false, errorRequest: true, error: { ...action.error } };

    default:
      return state;
  }
}
